import userFriendlyImage from '../assets/images/User_Friendly.png';
import parametricAnalysis from '../assets/images/ParametricAnalysis.png';
import reportGeneration from '../assets/images/ReportGeneration.png';
import surgeSwab from '../assets/images/SurgeSwab.png';
import rampSchedule from '../assets/images/RampSchedule.png';
import cloudBased from '../assets/images/CloudBased.png';
import fieldCapable from '../assets/images/FieldCapable.png';
import fastAccurate from '../assets/images/FastAccurate.png';
import rollOvers from '../assets/images/Rollovers.png';
import enverusIntegration from '../assets/images/Enverus.png';
import esdEcdOptimization from '../assets/images/ESDECD.png';
import tripAdvisor from '../assets/images/TripAdvisor.png';
import fluidTracking from '../assets/images/FluidTracking.png';
import pwdAdaptive from '../assets/images/PWD.png';
import featureRich from '../assets/images/FeatureRich.png';
import rheologyModelAnalysis from '../assets/images/Newton.png';
import { COLORS } from '../shared/config/colors';
import { VERSION } from '../shared/config/version';

export const USER_TYPE = {
  PREMIUM_ADMIN: 'PREMIUM_ADMIN',
  CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  CUSTOMER_ADMIN: 'CUSTOMER_ADMIN',
  CUSTOMER_USER: 'CUSTOMER_USER',
  CUSTOMER_RIG: 'CUSTOMER_RIG',
  PREMIUM_MPD_USER: 'PREMIUM_MPD_USER',
  PREMIUM_MPD_MANAGER: 'PREMIUM_MPD_MANAGER',
  PREMIUM_REALTIME_MPD_ADMIN: 'PREMIUM_REALTIME_MPD_ADMIN',
  MPD_CUSTOMER_USER: 'MPD_CUSTOMER_USER',
  PREMIUM_MARKETPLACE_ADMIN: 'PREMIUM_MARKETPLACE_ADMIN',
  SELLER_MARKETPLACE_ADMIN: 'SELLER_MARKETPLACE_ADMIN',
  PREMIUM_FIELD_TICKETING_ADMIN: 'PREMIUM_FIELD_TICKETING_ADMIN',
  PREMIUM_FIELD_TICKETING_USER: 'PREMIUM_FIELD_TICKETING_USER',
  PREMIUM_FIELD_TICKETING_MANAGER: 'PREMIUM_FIELD_TICKETING_MANAGER',
  PREMIUM_SELECT_ADMIN: 'PREMIUM_SELECT_ADMIN'
};

export const COMPANY_TYPE = {
  PREMIUM: 'PREMIUM',
  CUSTOMER: 'CUSTOMER',
  SELLER: 'SELLER',
  MARKETPLACE_CUSTOMER: 'MARKETPLACE_CUSTOMER',
  MPD_CUSTOMER: 'MPD_CUSTOMER'
};

export const COMPANY_ACCESS_ROLES = {
  PREMIUM: [
    'PREMIUM_ADMIN',
    'PREMIUM_FIELD_TICKETING_ADMIN',
    'PREMIUM_FIELD_TICKETING_MANAGER',
    'PREMIUM_FIELD_TICKETING_USER',
    'PREMIUM_MARKETPLACE_ADMIN',
    'PREMIUM_MPD_USER',
    'PREMIUM_MPD_MANAGER',
    'PREMIUM_REALTIME_MPD_ADMIN',
    'PREMIUM_SELECT_ADMIN'
  ],
  MPD_CUSTOMER: ['MPD_CUSTOMER_USER'],
  MARKETPLACE_CUSTOMER: [
    'CUSTOMER_ADMIN',
    'CUSTOMER_MANAGER',
    'CUSTOMER_RIG',
    'CUSTOMER_USER'
  ],
  SELLER: ['SELLER_MARKETPLACE_ADMIN']
};

export const USERS_CRUD_ACCESS_TYPES = [
  USER_TYPE.PREMIUM_ADMIN,
  USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
  USER_TYPE.PREMIUM_MARKETPLACE_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN
];

export const PARTS_CLASSIFICATION = {
  UNCLASSIFIED: '0',
  GREEN: '1',
  GRAY: '2',
};

export const DATAGRID_COLUMN_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  DATETIME: 'dateTime',
  BOOLEAN: 'boolean',
  SINGLE_SELECT: 'singleSelect',
  ACTIONS: 'actions',
};

export const CHART_TIMESTAMP_FORMAT = {
  month: '2-digit',
  day: '2-digit',
  hourCycle: 'h23',
  hour: '2-digit',
  minute: '2-digit',
};

export const GRID_COLUMNS_TO_EXCLUDE = [
  'id',
  '_id',
  'grid_id',
  'date',
  'time',
  'DATE',
  'TIME',
  'actuator',
];

export const CONTROLS_TYPE = {
  DATE_PRESETS_SLIDER: 'datePresets',
  SHOPPING_CART: 'shoppingCart',
  EPICOR_CONTROLS: 'epicorControls',
  FIREBASE_PAY_CONTROLS: 'firebasePayControls',
  FIREBASE_DRILL_CONTROLS: 'firebaseDrillControls',
  SEARCH_BOX: 'searchBox',
  SEARCH_AUTOCOMPLETE: 'searchAutoComplete',
  APPBAR_SUBTITLE: 'appbarsubtitle',
  EVENT_TAG: 'eventTag',
  ALARMS_CONTROLS: 'alarmsControls',
  DATE_RANGE_SEARCH: 'dateRangeSearch',
  ASPECT_RATIO: 'aspectRatio',
  TRANSACTION_CONTROLS: 'transactionControls',
  MARKETPLACE_TRANSACTION_CONTROLS: 'marketplaceTransactionControls',
  ALARM_HISTORY_CONTROLS: 'alarmHistoryControls',
  TRU_FLOW_CONTROLS: 'truFlowControls',
  PRINT_ORDER: 'printOrder',
  SYNC_MOBILE_DEVICES: 'syncMobileDevices',
  USERS_CONTROLS: 'userControls',
  COMPANY_CONTROLS: 'companyControls',
  WELLS_CONTROLS: 'wellsControls',
  INVENTORY_VIEW: 'inventoryView',
  AUDITLOG_CONTROLS: 'auditLogControls',
  HYDRAULICSLOG_CONTROLS: 'hyrdaulicsLogControls',
  MARKETPLACELOGS_CONTROLS: 'marketplaceLogControls',
  APPBAR_USERNAME: 'appbarUsername',
  ALARM_NOTIFICATION: 'alarmNotification',
  SELECTION_BOX: 'selectionBox',
  RIGS_CONTROLS: 'rigsControls',
  ASSETTYPE_CONTROLS: 'assetTypeControls',
  ASSETLIST_CONTROLS: 'assetListControls',
  ENVERUS_WELLS_CONTROLS: 'enverusWellsControls',
  CHECK_INS_CONTROLS: 'checkInsControls',
  CHECK_INS_DRILL_CONTROLS: 'checkInsDrillControls',
  DBW_VS_TARGET_CONTROLS: 'dbwVsTargetControls',
  TRANSACTION_HISTORY_KPI: 'TRANSACTION_HISTORY_KPI',
  CHECK_INS_KPI: 'CHECK_INS_KPI',
  JOBS_CONTROLS: 'jobsControls',
  FIELDBOXES_KPI_CONTROLS: 'fieldboxesKpiControls',
  SPEND_CONTROLS: 'spendControls',
  SEND_BIN_REMINDERS: 'sendBinReminders',
  SYNC_SIGNATURE_HARVEST: 'syncSignatureHarvest',
  USER_BUGS_CONTROLS: 'userBugsControls',
  MARKETSHARE_KPI_CONTROLS: 'marketshareKPIControls',
  FIELD_PICTURES_DRILL_CONTROLS: 'fieldPicturesDrillControls',
  REALTIME_COLLECTIONS_CONTROLS: 'realtimeCollectionsControls',
  PAY_TARGETS_CONTROLS: 'payTargetsControls',
  TARGET_ANSWERS_CONTROLS: 'targetAnswersControls'
};

export const PAGES_DATA = [
  {
    label: 'Users',
    link: '/Users',
    roles: [
      USER_TYPE.CUSTOMER_MANAGER,
      USER_TYPE.CUSTOMER_ADMIN,
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MARKETPLACE_ADMIN,
      USER_TYPE.SELLER_MARKETPLACE_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN
    ],
    controls: [CONTROLS_TYPE.USERS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Companies',
    link: '/Companies',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MARKETPLACE_ADMIN,
      USER_TYPE.SELLER_MARKETPLACE_ADMIN,
      USER_TYPE.CUSTOMER_MANAGER,
      USER_TYPE.CUSTOMER_ADMIN,
      USER_TYPE.CUSTOMER_USER,
      USER_TYPE.CUSTOMER_RIG,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [CONTROLS_TYPE.COMPANY_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Orders',
    link: '/Orders',
    roles: [USER_TYPE.CUSTOMER_USER, USER_TYPE.CUSTOMER_RIG],
    controls: [CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.SPEND_CONTROLS],
  },
  {
    label: 'Quotes',
    link: '/Quotes',
    roles: [USER_TYPE.CUSTOMER_USER, USER_TYPE.CUSTOMER_RIG],
    controls: [CONTROLS_TYPE.ASPECT_RATIO, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Shop',
    link: '/Shop',
    roles: [
      USER_TYPE.CUSTOMER_MANAGER,
      USER_TYPE.CUSTOMER_ADMIN,
      USER_TYPE.CUSTOMER_USER,
      USER_TYPE.CUSTOMER_RIG,
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MARKETPLACE_ADMIN,
      USER_TYPE.SELLER_MARKETPLACE_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.SHOPPING_CART,
      CONTROLS_TYPE.SEARCH_AUTOCOMPLETE,
      CONTROLS_TYPE.APPBAR_SUBTITLE,
      CONTROLS_TYPE.INVENTORY_VIEW,
      CONTROLS_TYPE.APPBAR_USERNAME,
      CONTROLS_TYPE.SELECTION_BOX
    ],
  },
  {
    label: 'Jobs',
    link: '/Jobs',
    selected: true,
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.MPD_CUSTOMER_USER,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [CONTROLS_TYPE.JOBS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Alarms',
    link: '/Alarms',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.SEARCH_BOX, CONTROLS_TYPE.ALARMS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Data',
    link: '/Data',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.MPD_CUSTOMER_USER,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.DATE_PRESETS_SLIDER,
      CONTROLS_TYPE.ALARM_NOTIFICATION,
      CONTROLS_TYPE.EVENT_TAG,
      CONTROLS_TYPE.ASPECT_RATIO,
      CONTROLS_TYPE.SPEED_CHART,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Asset Management',
    controls: [
      CONTROLS_TYPE.APPBAR_SUBTITLE,
      CONTROLS_TYPE.SEARCH_BOX,
      CONTROLS_TYPE.ASSETLIST_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN],
    submenu: [
      {
        label: 'Types',
        link: '/Assets/Types',
        controls: [
          CONTROLS_TYPE.SEARCH_BOX,
          CONTROLS_TYPE.ASSETTYPE_CONTROLS,
          CONTROLS_TYPE.APPBAR_USERNAME
        ],
      },
      {
        label: 'Map',
        link: '/Assets/Map',
        controls: [CONTROLS_TYPE.SEARCH_BOX, CONTROLS_TYPE.APPBAR_USERNAME]
      },
      {
        label: 'Assets',
        link: '/Assets',
        controls: [CONTROLS_TYPE.SEARCH_BOX, CONTROLS_TYPE.APPBAR_USERNAME]
      },
    ],
  },
  {
    label: 'Server-Side',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    submenu: [
      {
        label: 'Enverus',
        submenu: [
          {
            label: 'Rigs',
            link: '/Enverus/Rigs',
            controls: [
              CONTROLS_TYPE.SEARCH_BOX,
              CONTROLS_TYPE.RIGS_CONTROLS,
              CONTROLS_TYPE.APPBAR_USERNAME,
            ],
          },
          {
            label: 'Wells',
            link: '/Enverus/Wells',
            controls: [
              CONTROLS_TYPE.ENVERUS_WELLS_CONTROLS,
              CONTROLS_TYPE.APPBAR_USERNAME
            ],
          },
        ],
      },
      {
        label: 'Firebase',
        submenu: [
          {
            label: 'Pay',
            link: '/Firebase/Pay',
            controls: [CONTROLS_TYPE.FIREBASE_PAY_CONTROLS],
            submenu: []
          },
          {
            label: 'Drill',
            link: '/Firebase/Drill',
            controls: [CONTROLS_TYPE.FIREBASE_DRILL_CONTROLS],
            submenu: []
          },
        ]
      },
      {
        label: 'Epicor',
        submenu: [
          {
            label: 'Customers',
            link: '/Epicor/Customers',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
          {
            label: 'Parts',
            link: '/Epicor/Parts',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
          {
            label: 'Price Lists',
            link: '/Epicor/PriceLists',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
          {
            label: 'Sale Orders',
            link: '/Epicor/SaleOrders',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
          {
            label: 'Workforce',
            link: '/Epicor/Workforce',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
          {
            label: 'Bins',
            link: '/Epicor/Bins',
            controls: [CONTROLS_TYPE.EPICOR_CONTROLS],
          },
        ],
      },
      {
        label: 'Mongo',
        submenu: [
          {
            label: 'Realtime',
            link: '/RealtimeCollections',
            controls: [CONTROLS_TYPE.REALTIME_COLLECTIONS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
          },
        ]
      },
      {
        label: 'Field Pictures',
        submenu: [
          {
            label: 'Pay',
            link: '/FieldPictures/Pay',
          },
          {
            label: 'Drill',
            link: '/FieldPictures/Drill',
            controls: [
              CONTROLS_TYPE.FIELD_PICTURES_DRILL_CONTROLS,
              CONTROLS_TYPE.APPBAR_USERNAME,
            ],
          },
        ],
      },
    ],
  },
  {
    label: 'TruFlowSettings',
    link: '/TruFlowSettings',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.MPD_CUSTOMER_USER,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.APPBAR_SUBTITLE,
      CONTROLS_TYPE.TRU_FLOW_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Field Tickets',
    link: '/FieldTickets',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_USER,
      USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.APPBAR_SUBTITLE,
      CONTROLS_TYPE.PRINT_ORDER,
      CONTROLS_TYPE.ASPECT_RATIO,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Field Boxes',
    link: '/FieldBoxes',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_USER,
      USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.SEARCH_BOX,
      CONTROLS_TYPE.SYNC_MOBILE_DEVICES,
      CONTROLS_TYPE.SEND_BIN_REMINDERS,
      CONTROLS_TYPE.SYNC_SIGNATURE_HARVEST,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Wells',
    link: '/Wells',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN,
      USER_TYPE.MPD_CUSTOMER_USER
    ],
    controls: [
      CONTROLS_TYPE.SEARCH_BOX,
      CONTROLS_TYPE.WELLS_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME,
    ],
  },
  {
    label: 'Check Ins',
    link: '/CheckIns',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER,
      USER_TYPE.PREMIUM_SELECT_ADMIN,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.CHECK_INS_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Check Ins Drill',
    link: '/CheckInsDrill',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_MPD_USER,
      USER_TYPE.PREMIUM_MPD_MANAGER,
      USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.CHECK_INS_DRILL_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Market Share',
    link: '/Marketshare',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
      USER_TYPE.PREMIUM_SELECT_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER,
      USER_TYPE.PREMIUM_FIELD_TICKETING_USER
    ],
    controls: [
      CONTROLS_TYPE.SEARCH_BOX,
      CONTROLS_TYPE.DBW_VS_TARGET_CONTROLS,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Trucks',
    link: '/Trucks',
    roles: [
      USER_TYPE.PREMIUM_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
      USER_TYPE.PREMIUM_FIELD_TICKETING_USER,
      USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER,
      USER_TYPE.PREMIUM_SELECT_ADMIN
    ],
    controls: [
      CONTROLS_TYPE.APPBAR_SUBTITLE,
      CONTROLS_TYPE.ASPECT_RATIO,
      CONTROLS_TYPE.APPBAR_USERNAME
    ],
  },
  {
    label: 'Audit Log',
    link: '/AuditLog',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.AUDITLOG_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Hydraulics Log',
    link: '/HydraulicsLog',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN],
    controls: [CONTROLS_TYPE.HYDRAULICSLOG_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Marketplace Log',
    link: '/MarketplaceLog',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.MARKETPLACELOGS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Transaction History',
    link: '/TransactionHistory',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_USER, USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER, USER_TYPE.PREMIUM_MPD_USER, USER_TYPE.PREMIUM_MPD_MANAGER, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.TRANSACTION_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Alarm History',
    link: '/AlarmHistory',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN],
    controls: [CONTROLS_TYPE.ALARM_HISTORY_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'Marketplace Transactions',
    link: '/MarketplaceTransactions',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_MARKETPLACE_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.MARKETPLACE_TRANSACTION_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    label: 'TransactionHistory KPIs',
    link: '/TransactionHistory/KPIs',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.TRANSACTION_HISTORY_KPI, CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.APPBAR_SUBTITLE],
  },
  {
    label: 'CheckIns KPIs',
    link: '/CheckIns/KPIs',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER, USER_TYPE.PREMIUM_SELECT_ADMIN, USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN],
    controls: [CONTROLS_TYPE.CHECK_INS_KPI, CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.APPBAR_SUBTITLE],
  },
  {
    label: 'FieldBoxes KPIs',
    link: '/FieldBoxes/KPIs',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.FIELDBOXES_KPI_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.APPBAR_SUBTITLE],
  },
  {
    label: 'Marketshare KPIs',
    link: '/Marketshare/KPIs',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.MARKETSHARE_KPI_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.APPBAR_SUBTITLE],
  },
  {
    label: 'Premium Pay Targeting',
    link: '/PayTargets',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.PAY_TARGETS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
  },
  {
    link: '/TargetAnswers',
    roles: [USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN, USER_TYPE.PREMIUM_SELECT_ADMIN],
    controls: [CONTROLS_TYPE.TARGET_ANSWERS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME, CONTROLS_TYPE.APPBAR_SUBTITLE,],
  },
  {
    label: 'About',
    roles: Object.values(USER_TYPE),
    submenu: [
      {
        label: 'Known Issues',
        link: '/KnownIssues',
        controls: [CONTROLS_TYPE.USER_BUGS_CONTROLS, CONTROLS_TYPE.APPBAR_USERNAME],
      },
      {
        label: 'Versions',
        submenu: [
          {
            label: `Frontend: ${VERSION}`
          }
        ]
      },
    ],
  },
  { link: '/PrivacyPolicy', roles: ['*'] },
  { link: 'Unauthorized', roles: ['*'] },
];

export const UNASSIGNED_ASSET_JOB_ID = '-1';

export const JOBS_SYSTEM_STATUS = {
  NO_ACTUATOR_DATA: -1,
  NONE: 0,
  FAULTS_ONLY: 1,
  WARNINGS_ONLY: 2,
  BOTH: 3,
};

export const FIELDBOX_LASTCHANGED = {
  STATUS_ONE: 1,
  STATUS_TWO: 2,
  STATUS_THREE: 3,
};

export const CALENDER_PROPS = {
  format: 'MM/dd/yyyy HH:mm',
  timeSteps: { hours: 1, minutes: 1 },
  ampm: false,
  desktopModeMediaQuery: '@media (pointer: none)',
};

export const DEFAULT_PRESET = 120;
export const DEFAULT_MOBILE_PRESET = 360;
export const DEFAULT_MINUTES_PRESET = 15;

export const HOURS_RANGE_PRESETS = [
  {
    label: '2hrs',
    value: 120,
  },
  {
    label: '4hrs',
    value: 240,
  },
  {
    label: '6hrs',
    value: 360,
  },
  {
    label: '8hrs',
    value: 480,
  },
];

export const MINUTES_RANGE_PRESETS = [
  {
    label: '2mins',
    value: 2,
  },
  {
    label: '15mins',
    value: 15,
  },
  {
    label: '30mins',
    value: 30,
  },
  {
    label: '45mins',
    value: 45,
  },
  {
    label: '1h',
    value: 60,
  },
];

export const DRILLING_FILTERS = [
  {
    id: 0,
    header: 'MPD',
    fields: [
      {
        fieldName: 'Pump Pressure',
        column: 'SPPA',
        color: '75757599',
      },
      {
        fieldName: 'Choke Pressure',
        column: 'SBP1',
        color: '2B78EA',
      },
      {
        fieldName: 'Choke Position',
        column: 'SPNRNG1',
        color: '00000099',
      },
      {
        fieldName: 'Measured Depth',
        column: 'DEPTMEAS',
        color: 'FF0000',
      },
    ],
  },
  {
    id: 1,
    header: 'Drilling Performance',
    fields: [
      {
        fieldName: 'WOB',
        column: 'WOBA',
        color: '99C13B',
      },
      {
        fieldName: 'ROP',
        column: 'ROPA',
        color: '2B78EA',
      },
      {
        fieldName: 'RPM',
        column: 'RPMA',
        color: '00000042',
      },
      {
        fieldName: 'Torque',
        column: 'TORQA',
        color: '00000073',
      },
      {
        fieldName: 'Measured Depth',
        column: 'DEPTMEAS',
        color: 'FF0000',
      },
    ],
  },
  {
    id: 2,
    header: 'Custom',
    fields: [],
  },
];

export const ACTUATOR_FILTERS = [
  {
    id: 0,
    header: 'Custom',
    fields: [
      {
        column: '~1_bMotorEnableState',
        fieldName: 'Motor State',
        color: '00000033',
      },
      {
        column: '~1_eCurrentControlMode',
        fieldName: 'Control Mode',
        color: '000000',
      },
      {
        column: '~1_rActualTorque',
        fieldName: 'Torque',
        color: 'FF000080',
      },
      {
        column: '~1_rDesiredPressure',
        fieldName: 'Pressure Setpoint',
        color: '2348ED',
      },
      {
        column: '~1_rMeasuredPressure',
        fieldName: 'Measured Pressure',
        color: '3BA5D682',
      },
      {
        column: '~1_rSpanPercentage',
        fieldName: 'Choke Position',
        color: '000000B3',
      },
    ],
  },
];

export const DEFAULT_ACTUATOR_FILTERS = [
  {
    id: 0,
    header: 'Custom',
    fields: [
      {
        column: 'bMotorEnableState',
        fieldName: 'Motor State',
        color: '00000033',
      },
      {
        column: 'eCurrentControlMode',
        fieldName: 'Control Mode',
        color: '000000',
      },
      {
        column: 'rActualTorque',
        fieldName: 'Torque',
        color: 'FF000080',
      },
      {
        column: 'rDesiredPressure',
        fieldName: 'Pressure Setpoint',
        color: '2348ED',
      },
      {
        column: 'rMeasuredPressure',
        fieldName: 'Measured Pressure',
        color: '3BA5D682',
      },
      {
        column: 'rSpanPercentage',
        fieldName: 'Choke Position',
        color: '000000B3',
      },
    ],
  },
];

export const ACTUATOR_REPORT = [
  {
    id: 0,
    header: 'MPD Utilization',
    fields: [
      {
        fieldName: 'Specify date range and click on the Report button',
      },
    ],
  },
  {
    id: 1,
    header: 'RCD (Bearing Assy)',
    fields: [
      {
        fieldName:
          'Specify date range when bearing assembly was installed and removed then click on the Report button',
      },
    ],
  },
];

export const DEFAULT_DRILLING_FILTERS = [
  {
    id: 0,
    header: 'MPD',
    fields: [
      {
        fieldName: 'Pump Pressure',
        column: 'SPPA',
        color: '75757599',
        number: false
      },
      {
        fieldName: 'Choke Pressure',
        column: 'SBP',
        color: '2B78EA',
        number: true
      },
      {
        fieldName: 'Choke Position',
        column: 'SPNRNG',
        color: '00000099',
        number: true
      },
      {
        fieldName: 'Measured Depth',
        column: 'DEPTMEAS',
        color: 'FF0000',
        number: false
      },
    ],
  },
  {
    id: 1,
    header: 'Drilling Performance',
    fields: [
      {
        fieldName: 'WOB',
        column: 'WOBA',
        color: '99C13B',
        number: false
      },
      {
        fieldName: 'ROP',
        column: 'ROPA',
        color: '2B78EA',
        number: false
      },
      {
        fieldName: 'RPM',
        column: 'RPMA',
        color: '00000042',
        number: false
      },
      {
        fieldName: 'Torque',
        column: 'TORQA',
        color: '00000073',
        number: false
      },
      {
        fieldName: 'Measured Depth',
        column: 'DEPTMEAS',
        color: 'FF0000',
        number: false
      },
    ],
  },
  {
    id: 2,
    header: 'Custom',
    fields: [],
  },
];

export const OPERATOR_SYMBOLS_PRESET = [
  {
    operator: '<',
    label: 'lessThan'
  },
  {
    operator: '<=',
    label: 'lessThanEquals'
  },
  {
    operator: '>',
    label: 'greaterThan'
  },
  {
    operator: '>=',
    label: 'greaterThanEquals'
  },
  {
    operator: '=',
    label: 'equals'
  },
  {
    operator: '!=',
    label: 'notEquals'
  },
];

export const ENVERUS_WELLS_SEARCH_FILTERS = ['ENVBasin', 'API_UWI_Unformatted', 'WellID', 'ENVOperator'];

export const DEVICE_CLASSIFICATION = {
  DESKTOP: 1,
  TABLET: 2,
  MOBILE: 3,
};

export const WELLS_DRILL_STRING_VALIDATION = {
  name: 'Name should be limited to 100 characters',
  od: 'OD should be a number larger than ID',
  id: 'ID should be a number greater than or equal to 1.0 inch',
  tj_od: 'Tooljoint OD should be a number greater than or equal to 0.0',
  tj_id: 'Tooljoint ID should be a number greater than or equal to 0.0',
  len: 'Length should be a number greater than 0.0',
  tj_len: 'Tooljoint length percentage should be a number between 0 and 15',
  tj_len_non_zero_tj_od: 'Tooljoint OD should be greater than or equal to OD when Tooljoint length percentage is not zero',
  tj_len_min_tj_id: 'Tooljoint ID should be greater than or equal to 1.0 inch when Tooljoint length percentage is not zero'
};

export const WELLS_DRILL_FLUID_VALIDATION = {
  MW: 'Mud weight should be greater than 5.0 ppg',
  FANN_300: 'Fann 300 should be less than or equal to Fann 600',
  FANN_200: 'Fann 200 should be less than or equal to Fann 300',
  FANN_100: 'Fann 100 should be less than or equal to Fann 200',
  FANN_6: 'Fann 6 should be less than or equal to Fann 100',
  FANN_6_300: 'Fann 6 should be less than Fann 300',
  FANN_3: 'Fann 3 should be greater than 0 and less than or equal to Fann 6',
  GEL_10MIN: 'Gel 10 min should be greater than 0 and greater than or equal to Gel 10 sec',
  GEL_10SEC: 'Gel 10 sec should be greater than 0',
};

export const WELLS_GEOMETRY_TYPE = ['Casing', 'Liner', 'Open Hole'];

export const WELLS_DRILL_STRING_BIT_TYPE = ['PDC', 'Roller Cone'];

export const MAP_PIN_SIZE = {
  desktop: [25, 35],
  mobile: [12, 16]
};

export const SPECIAL_INSTRUCTIONS = [
  { value: 1, label: 'Split Orders by CostCode' },
  { value: 2, label: 'Notify Approvers' },
  { value: 3, label: 'Notify Admins' },
  { value: 4, label: 'Epicor Transaction' },
  { value: 5, label: 'MKT Admins' },
  { value: 6, label: 'Sales Reps' },
];

export const MKT_ACTIONS = {
  PAGE_LOADED: 'PAGE_LOADED'
};

export const FIELDBOX_KPI_DIVISION_MAP = {
  APPALACHIA: ['APP'],
  ROCKIES: ['UTAH', 'CAS', 'ROCKIES'],
  CALIFORNIA: ['CALI'],
  'EAST TEXAS/LOUISIANA': ['CSTAT', 'NTX'],
  'NORTH DAKOTA': ['ND'],
  'WEST TEXAS': ['WTX', 'NMEX'],
  OKLAHOMA: ['OK'],
  'SOUTH TEXAS': ['STX']
};

export const DIVISIONS = [
  'ALL',
  'HOUSTON HQ',
  'WEST TEXAS',
  'NORTH TEXAS',
  'SOUTH TEXAS',
  'OKLAHOMA',
  'ROCKIES',
  'NORTH DAKOTA',
  'APPALACHIA',
  'CALIFORNIA'];

export const PREMIUM_SOCIALS = {
  linkedin: 'https://www.linkedin.com/company/premium-oilfield-supply/',
  youtube: 'https://www.youtube.com/@premiumoilfieldtechnologie8675',
  instagram: 'https://www.instagram.com/premiumoilfieldtechnologies/',
  facebook: 'https://www.facebook.com/premiumoilfield/'
};

export const HYDRAULICS_RUN_DETAILS = {
  BIT_DEPTH: 'Bit depth should be greater than or equal to 0',
  HOLE_DEPTH: 'Hole depth should be greater than or equal to 0',
  FLOW_IN: 'Flow rate should be greater than or equal to 0',
  SBP: 'SBP should be greater than or equal to 0',
};

export const DEFAULT_SCREEN_VIEW_MODE = {
  aspectRatioPage: { maxWidth: 'xl', style: { padding: 0 } },
  aspectChanged: true
};

export const SPEND_CHART_FILTER = [
  { value: 'year', label: 'Year' },
  { value: 'month', label: 'Month' },
  { value: 'week', label: 'Week' },
];

export const LIVE_HELP_USER_TYPES = [USER_TYPE.CUSTOMER_USER, USER_TYPE.CUSTOMER_RIG];

export const HYDRAULICS_TRIP_PIPE_TYPE = ['Close-ended Pipe', 'Drillstring', 'Open-ended Pipe'];

export const HYDRAULICS_TRIP_PIPE_TYPE_VALUE = {
  'Close-ended Pipe': 'close_ended_pipe',
  Drillstring: 'drillstring',
  'Open-ended Pipe': 'open_ended_pipe'
};

export const UNIT_SYSTEM_LABEL = {
  'Metric (SI)': 'SI',
  'Imperial (US)': 'US'
};

export const HYDRAULICS_LANDING_FEATURES = [
  { id: 1, label: 'User Friendly', image: userFriendlyImage },
  { id: 2, label: 'Fast & Accurate', image: fastAccurate },
  { id: 3, label: 'Cloud Based', image: cloudBased, reduceSize: true },
  { id: 4, label: 'Field Capable', image: fieldCapable },
  { id: 5, label: 'Comprehensive Rheological Modeling', image: rheologyModelAnalysis, reduceSize: true },
  { id: 6, label: 'ESD & ECD Optimization', image: esdEcdOptimization },
  { id: 7, label: 'Ramp Schedules', image: rampSchedule },
  { id: 8, label: 'Surge & Swab', image: surgeSwab },
  { id: 9, label: 'Trip Advisor', image: tripAdvisor },
  { id: 10, label: 'Rollovers', image: rollOvers },
  { id: 11, label: 'Parametric Analysis', image: parametricAnalysis },
  { id: 12, label: 'Fluid Tracking', image: fluidTracking },
  { id: 13, label: 'PWD Adaptive', image: pwdAdaptive },
  { id: 14, label: 'Feature Rich', image: featureRich },
  { id: 15, label: 'Report Generation', image: reportGeneration },
  { id: 16, label: 'Enverus Integration', image: enverusIntegration }
];
export const TOOLTIP_COLORS = {
  background: '#38b6FF',
  color: '#FFF'
};
export const HYDRAULICS_LANDING_CHART_TYPES = [
  { id: 0, label: 'Wellbore Hydraulics' },
  // { id: 1, label: 'CHBP Rollover' },
  { id: 2, label: 'Parametric Analysis' }
];
export const PSA_ACCESS_LEVELS_RESTRICT = {
  PREMIUM_MPD_USER: ['PREMIUM_REALTIME_MPD_ADMIN', 'PREMIUM_MPD_MANAGER'],
  PREMIUM_MPD_MANAGER: ['PREMIUM_MPD_USER', 'PREMIUM_REALTIME_MPD_ADMIN'],
  PREMIUM_REALTIME_MPD_ADMIN: ['PREMIUM_MPD_USER', 'PREMIUM_MPD_MANAGER'],
  PREMIUM_FIELD_TICKETING_USER: ['PREMIUM_FIELD_TICKETING_ADMIN', 'PREMIUM_FIELD_TICKETING_MANAGER'],
  PREMIUM_FIELD_TICKETING_ADMIN: ['PREMIUM_FIELD_TICKETING_USER', 'PREMIUM_FIELD_TICKETING_MANAGER'],
  PREMIUM_FIELD_TICKETING_MANAGER: ['PREMIUM_FIELD_TICKETING_USER', 'PREMIUM_FIELD_TICKETING_ADMIN'],
};

export const PARAMETER_ANALYSIS_FILTER_PARAMS = ['rop', 'rpm', 'flow_in', 'sbp', 'mw', 'hole_depth'];

export const PARAMETER_ANALYSIS_TYPE = ['Hole Depth', 'ROP', 'RPM', 'Flow Rate', 'MW'];

export const PARAMETER_ANALYSIS_TYPE_VALUE = {
  flow_in: 'Flow Rate',
  rop: 'ROP',
  rpm: 'RPM',
  mw: 'MW',
  hole_depth: 'Hole Depth'
};

export const PARAMETRIC_ANALYSIS_FILTER_LABEL = ['Value#1', 'Value#2', 'Value#3', 'Value#4', 'Value#5', 'Value#6', 'Value#7'];

export const FILTER_STYLE_PARAMETRIC_ANALYSIS = {
  'Value#1': {
    markerType: 'circle',
    color: COLORS.BRIGHT_RED,
    lineDashType: 'solid',
    lineDashStyle: 'solid'
  },
  'Value#2': {
    markerType: 'square',
    color: COLORS.GREEN,
    lineDashType: 'dot',
    lineDashStyle: 'dotted'
  },
  'Value#3': {
    markerType: 'triangle',
    color: COLORS.BLUE,
    lineDashType: 'dash',
    lineDashStyle: 'dashed'
  },
  'Value#4': {
    markerType: 'cross',
    color: COLORS.ORANGE,
    lineDashType: 'dashDot',
    lineDashStyle: 'dashDot'
  },
  'Value#5': {
    markerType: 'circle',
    color: COLORS.LIGHT_RED,
    lineDashType: 'solid',
    lineDashStyle: 'solid'
  },
  'Value#6': {
    markerType: 'square',
    color: COLORS.LIME_GREEN,
    lineDashType: 'dash',
    lineDashStyle: 'dashed'
  },
  'Value#7': {
    markerType: 'triangle',
    color: COLORS.LIGHT_BLUE,
    lineDashType: 'dashDot',
    lineDashStyle: 'dashDot'
  },
};

export const USER_BUG_PROGRESS_LEVEL = {
  0: 'Submitted',
  1: 'In Progress',
  2: 'Completed'
};

export const USER_BUG_FILES_UPLOAD_SIZE = {
  image: 3 * 1024 * 1024, // 3MB
  video: 75 * 1024 * 1024, // 75MB
  other: 30 * 1024 * 1024, // 30MB
};

export const STRIPPING_REPORT_EVERY_US = [100, 200, 500, 1000];

export const STRIPPING_REPORT_EVERY_SI = [50, 100, 200, 500];

export const STRIPPING_TYPE_PRIMARY = [
  {
    label: 'Stripping Pressure',
    field: 'surge',
  },
  {
    label: 'ECD',
    field: 'ecd_with_sbp',
    name: 'ECD (Stripping)'
  },
  {
    label: 'ESD',
    field: 'esd_with_sbp',
    name: 'ESD (Connection)'
  },
  {
    label: 'Stripping SBP',
    field: 'target_sbp',
  },
  {
    label: 'Connection SBP',
    field: 'connection_sbp',
  },
];

export const STRIPPING_TYPE_SECONDARY = [
  {
    label: 'Casing Shoe',
    field: 'casing_shoe',
  },
  {
    label: 'Landing Point',
    field: 'landing_point',
  },
  {
    label: 'Hole Depth',
    field: 'hole_depth',
  }
];

export const STRIPPING_RUN_MAP = [
  '50 ft/min',
  '100 ft/min',
  '150 ft/min',
  '200 ft/min',
];

export const CHART_MARKERTYPES = ['none', 'circle', 'square', 'triangle', 'cross',];

export const HYDRAULICS_MAX_FILE_SIZE = {
  ONE_MB: 1,
  ONE_MB_BYTE: 1048576
};

export const DATAGRID_TABLE_CELL_WIDTH = {
  MINWIDTH: 150,
  MAXWIDTH: 250,
};

export const ANCHOR_POINT_TYPES = ['None', 'Hole Depth', 'Casing Shoe', 'Landing Point'];

export const MAX_ROW_LIMITS = {
  WELLS_OBSERVATION: 3,
  STRIPPING: 5,
  PARAMETRIC: 3,
  DISPLACEMENT: 10,
  RUNS_ECD_SPAN: 3
};

export const MAX_OBSERVATION_POINT_NAME_LENGTH = 13;

export const HYDRAULICS_RUN_NOTES_MAX_LENGTH = 100;

export const IMPORT_TABLES_LIST = [
  {
    label: 'Surveys',
    key: 'WellsSurveys',
  },
  {
    label: 'Window',
    key: 'WellsWindows',
  },
  {
    label: 'Geometry',
    key: 'WellsGeometries'
  },
  {
    label: 'Drillstrings',
    key: 'WellsDrillStrings'
  },
  {
    label: 'Drilling Fluids',
    key: 'WellsDrillFluids'
  },
  {
    label: 'PWD',
    key: 'WellsPWD'
  },
  {
    label: 'HYDRAULICS RUNS',
    key: 'HydraulicsRuns'
  },
  {
    label: 'PERMISSIONS',
    key: 'Permissions'
  }
];

export const fieldboxKpiAccessLevels = [
  USER_TYPE.PREMIUM_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER
];

export const MARKETSHARE_KPI_ACCESS_LEVELS = [
  USER_TYPE.PREMIUM_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN,
  USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER
];

export const MARKETSHARE_CLASSES = ['MPE DBW', 'NON-MPE DBW', 'DBW', 'TARGET'];

export const MAIN_DEPTH_POINTS = ['Hole Depth', 'Casing Shoe', 'Landing Point'];

export const WELLS_OBSERVATION_POINTS = ['Casing Shoe', 'KOP', 'Landing Point'];

export const CONTROL_TABLE_DROPDOWN_VALUES = {
  maintain: ['Lowest', 'Highest'],
  parameter: ['SBP', 'Rate']
};

export const CONTROL_TABLE_PARAMETER_MAP = {
  SBP: 'sbp',
  Rate: 'rate',
  'Trip Speed': 'trip_speed',
};

export const CONTROL_TABLE_STEP_SIZE_DIVISION_COUNT = {
  min: 50,
  max: 3
};

export const DISPLACEMENT_STEP_SIZE_DIVISION_COUNT = {
  min: 250,
  max: 3
};

export const HIDE_TARGET_ECD = ['None', 'CBHP', 'Controls Table'];

export const HIDE_TARGET_IN_RUN_TYPE = ['stripping', 'displacement'];

export const WELLBORE_DRILL_FLUID = { _id: 'air_filling_mud', name: 'Air', MD: 0 };

export const HYDRAULICS_RUN_TYPES = {
  HYDRAULICS: {
    name: 'Hydraulics',
    typeKey: 'hydraulicsRun',
    icon: 'DirectionsRunRounded'
  },
  STRIPPING: {
    name: 'Stripping',
    typeKey: 'stripping',
    icon: 'SwapVertOutlined'
  },
  ROLLOVER: {
    name: 'Rollover',
    typeKey: 'rollover',
    icon: 'RotateLeftRounded'
  },
  PARAMETRIC_ANALYSIS: {
    name: 'Parametric Analysis',
    typeKey: 'parametricAnalysis',
    icon: 'CandlestickChartOutlined'
  },
  DISPLACEMENT: {
    name: 'Displacement',
    typeKey: 'displacement',
    icon: 'ReadMoreOutlined'
  },
};

export const HYDRAULICS_MODEL = [
  'BEST FIT',
  'YPL (Herschel Bulkley)',
  'API-RP-YPL (Curve Fit)',
  'API-RP-YPL (2023)',
  'Power Law',
  'Bingham Plastic',
  'Newtonian'];

export const HYDRAULICS_MODEL_VALUES = {
  'BEST FIT': 'best_fit',
  'API-RP-YPL (Curve Fit)': 'api_rp_ypl_fit',
  'API-RP-YPL (2023)': 'api_rp_ypl',
  'YPL (Herschel Bulkley)': 'ypl',
  'Power Law': 'pl',
  'Bingham Plastic': 'bingham',
  Newtonian: 'newtonian'
};

export const REPORT_INPUT_LIST = [
  {
    label: 'Surveys',
    key: 'WellsSurveys',
  },
  {
    label: 'Geometry',
    key: 'WellsGeometries'
  },
  {
    label: 'Drillstrings',
    key: 'WellsDrillStrings'
  },
  {
    label: 'Drilling Fluids',
    key: 'WellsDrillFluids'
  },
  {
    label: 'Drilling Window',
    key: 'WellsWindows',
  },
  {
    label: 'Observation Points',
    key: 'WellsObservationPoints'
  },
];

export const ROLLOVER_DISPLACEMENT_TYPE_SECONDARY = [
  {
    label: 'Casing Shoe',
    field: ['icp_esd', 'icp_ecd'],
  },
  {
    label: 'Landing Point',
    field: ['lp_esd', 'lp_ecd'],
  },
  {
    label: 'Hole Depth',
    field: ['bh_esd', 'bh_ecd'],
  }
];

export const TOOLTIPS = {
  save: 'Save',
  submit: 'Submit',
  rampSchedule: 'Ramp Schedule',
  printReport: 'Print Report',
  viewReport: 'View Report',
  viewRunInputs: 'View Run Inputs',
  volumeCalculator: 'Volume Calculator',
  delete: 'Delete',
  uploadJson: 'Upload JSON',
  downloadJson: 'Download JSON',
  copy: 'Copy',
  importFromWell: 'Import From Well',
  wellsObservationPoints: 'Observation Points',
  drillingBit: 'Drilling Bit',
  downloadWellsInputs: 'Download Well Inputs',
  viewPermissions: 'View Permissions',
  mdTvdInterpolation: 'MD/TVD Interpolation'
};

export const SHORTCUT_LISTS_HYDRAULICS = [
  { label: 'Surveys', key: 'survey' },
  { label: 'Geometry', key: 'geometry' },
  { label: 'Drillstrings', key: 'drillString' },
  { label: 'Drilling Fluids', key: 'drillFluid' },
  { label: 'Drilling Window', key: 'window' },
];

export const SYNC_SIGNATURE_HARVEST_MAP = {
  '00': 'DEFAULT',
  '01': 'HOUSTON HQ',
  '02': 'WEST TEXAS',
  '03': 'NORTH TEXAS',
  '04': 'SOUTH TEXAS',
  '05': 'GULF COAST',
  '06': 'OKLAHOMA',
  '07': 'ROCKIES',
  '08': 'NORTH DAKOTA',
  '09': 'FIELD SERVICE',
  10: 'APPALACHIA',
  11: 'MENA',
  12: 'SUPREME',
  13: 'COLLEGE STATION',
  14: 'CARLSBAD NEW MEXICO',
  15: 'RCD/MPD SOLUTIONS',
  16: 'SMDI',
  17: 'LATIN AMERICA',
  18: 'OMAN',
  19: 'KUWAIT',
  20: 'SAUDI ARABIA',
  21: 'MANAGED PRESSURE DRILLING',
  22: 'CASPER WY',
  23: 'WELL SERVICE AND REPAIR WT',
  24: 'CALIFORNIA',
  25: 'UTAH',
  26: 'ALASKA'
};

export const MANAGING_DIVISIONS = [
  'WEST TEXAS',
  'NORTH DAKOTA',
  'OKLAHOMA',
  'APPALACHIA',
  'SOUTH TEXAS',
  'EAST TEXAS/LOUISIANA',
  'ROCKIES'
];

export const REPORT_DOWNLOAD_OPTIONS = ['View', 'Print', 'Data'];

export const HYDRAULICS_ADMIN_ROLES = [USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN, USER_TYPE.PREMIUM_ADMIN, USER_TYPE.PREMIUM_MPD_MANAGER];

export const EDIT_PERMISSION_KEYS = [
  { value: 'create', label: 'Create / Copy' },
  { value: 'update', label: 'Update' },
  { value: 'read', label: 'Read' },
  { value: 'delete', label: 'Delete' }
];

export const PERMISSION_DIALOG_SOURCES = {
  wellsInfos: { label: '', collectionName: 'WellsInfos' },
  wellsSurveys: { label: 'Surveys', collectionName: 'WellsSurveys' },
  wellsWindows: { label: 'Window', collectionName: 'WellsWindows' },
  wellsGeometries: { label: 'Geometry', collectionName: 'WellsGeometries' },
  wellsDrillStrings: { label: 'Drillstrings', collectionName: 'WellsDrillStrings' },
  wellsDrillFluids: { label: 'Drilling Fluids', collectionName: 'WellsDrillFluids' },
  wellsPwd: { label: 'PWD', collectionName: 'WellsPWD' },
  wellsObservationPoints: { label: 'Wells Observation Points', collectionName: 'WellsObservationPoints' },
  wellsHydraulics: { label: 'Hydraulic Runs', collectionName: 'HydraulicsRuns' }
};

export const PERMISSION_USERS_CATEGORY = ['All Users'];

export const APP_ACTION_TYPES = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  COPY: 'COPY',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  IMPORT: 'IMPORT',
  DOWNLOAD: 'DOWNLOAD'
};

export const APP_ACTION_COLUMNS = [
  'actions',
  'notes',
  'submit',
  'results',
  'hide',
  'wellBoreInitialization',
  'target_data'
];

export const ACTION_PERMISSION_MAP = {
  [APP_ACTION_TYPES.VIEW]: 'read',
  [APP_ACTION_TYPES.DOWNLOAD]: 'read',
  [APP_ACTION_TYPES.CREATE]: 'create',
  [APP_ACTION_TYPES.COPY]: 'create',
  [APP_ACTION_TYPES.IMPORT]: 'create',
  [APP_ACTION_TYPES.UPDATE]: 'update',
  [APP_ACTION_TYPES.DELETE]: 'delete',
};

export const HYDRAULICS_FULL_ACCESS_PERMISSIONS = {
  read: true,
  update: true,
  delete: true,
  create: true
};

export const REPORT_INVENTORY_WITH_PACK_NUM = ['Box Ticket', 'Portal Box Ticket', 'Truck Sale'];

export const PAY_TARGET_ADD_QUESTION_RIG_COUNT_LIMIT = 2500;
